import { ReactNode } from 'react';
import { Heading as HeadingPrimitive, HeadingProps } from '../../typography';

type AlertDialogHeadingProps = HeadingProps;

export function AlertDialogHeading(props: AlertDialogHeadingProps): ReactNode {
  return (
    <HeadingPrimitive
      as="h1"
      fontSize="18px"
      lineHeight="32px"
      fontWeight={500}
      {...props}
    />
  );
}
